import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["amountField", "preset"]
  }

  connect() {
    this.syncPresets()
  }

  selectPreset(event) {
    this.amountFieldTarget.value = event.currentTarget.dataset.suggestedAmount
    this.syncPresets()
  }

  syncPresets() {
    const currentAmount = this.amountFieldTarget.value

    this.presetTargets.forEach((preset) => {
      preset.checked = preset.dataset.suggestedAmount === currentAmount
    })
  }
}
